import React, {
  useState,
  useEffect,
  useImperativeHandle,
  forwardRef,
  useRef,
} from "react";
import {
  Card,
  TextBox,
  Button,
  Select,
  IconInfo,
  TextArea,
  RadioGroup,
  RadioButton,
  FilePicker,
  Accordion,
} from "@veneer/core";
import { Container } from "react-bootstrap";
import { useAppSelector, useAppDispatch } from "@store/hooks";
import type { RootState } from "@store/store";
import { useTranslation } from "react-i18next";

import { clearContactDetails } from "@store/reducers/fetch-contact-details-info-apis";

import "./case-contact.scss";

import CasePrimaryAddress from "./case-primary-address/case-primary-address";
import CaseAlternateAddress from "./case-alternate-address/case-alternate-address";
import { submitFormRef } from "@constants/case-create";

interface CaseAddressRef {
  submitForm: () => boolean;
}

const CaseContact = forwardRef<submitFormRef>((_, ref) => {
  // const CaseContact = forwardRef((ref) => {
  const dispatch = useAppDispatch();
  
  const casePrimaryChildRef = useRef<submitFormRef>(null);
  const caseAlternateRef = useRef<CaseAddressRef>(null);
  const [primaryContactInformation, setPrimaryContactInformation] = useState<
    any[]
  >([]);
  const [alternateContactInformation, setAlternateContactInformation] =
    useState<any[]>([]);

    const {t} = useTranslation();
  const alternateHeaderContent =
    "To alter a secondary or alternate contact, select a different name from the saved contact pull-down. To use a completely new contact, select the “create a new contact” value in the pull-down, and do not edit an existing contact’s information.";
  // const primaryHeaderContent = `The primary information is auto-filled from the submitter's profile by default. To change the contact, select a differnent name from the saved contact pull-down. To use a completely new contact , select a "create a new contact" value in the pull-down, and do not edit an existing contact's information.`;
  const primaryHeaderContent = t("HPI.CreateCase.primarycontact.primaryheaderContent",{defaultValue:`Please provide the contact details of the person who will receive case updates and respond to queries from the support team.`});
  const { contactDetails } = useAppSelector(
    (state: RootState) => state.fetchContactDetailsInfoAPI
  );

  useEffect(() => {
    if (contactDetails) {
      dispatch(clearContactDetails());
    }
  }, [contactDetails]);


  useEffect(() => {
    
    setAlternateContactInformation([
      {
        content: (
          <CaseAlternateAddress
            headerContent={alternateHeaderContent}
            ref={caseAlternateRef}
          />
        ),
        header: { centralArea: <h5 className="subtitle-large">{t("HPI.CreateCase.alternatecontact",{ defaultValue: 'Alternate contact information' })}
</h5> },
        id: "supportOptions",
      },
    ]);
  }, []);

  // const handleExpand = (event: any, index: any, item: any) => {
  //   setAccordionItems((prevItems) =>
  //     prevItems.map((itm, idx) =>
  //       idx === index ? { ...itm, expanded: true } : itm
  //     )
  //   );
  // };

  // const handleCollapse = (event: any, index: any, item: any) => {
  //   setAccordionItems((prevItems) =>
  //     prevItems.map((itm, idx) =>
  //       idx === index ? { ...itm, expanded: false } : itm
  //     )
  //   );
  // };

  useImperativeHandle(ref, () => ({
    submitForm: () => {
      let isPrimaryValid = casePrimaryChildRef.current?.submitForm().isValid ?? false;
      let isAlternativeValid = caseAlternateRef.current?.submitForm() ?? false;
      if(!isAlternativeValid) {
        expendAccordion()
        }
      return {isValid: isPrimaryValid && isAlternativeValid, errorText: casePrimaryChildRef.current?.submitForm().errorText};
    },
  }));
  
  const expendAccordion = () => {
    document.querySelectorAll('.vn-animated-height__container').forEach((el) => {
          if (el instanceof HTMLElement) {
            el.classList.add('vn-animated-height__container--entered');
          }
        });
        const el = document.getElementById('supportOptions');
        if (el instanceof HTMLElement) {
          el.setAttribute('aria-hidden', 'false');
        }
  }

  return (
    <div className="card-contact-container">
      <div>
        <CasePrimaryAddress
          headerContent={primaryHeaderContent}
          ref={casePrimaryChildRef}
          headerTitle={t("HPI.CreateCase.SubmitterInformation", {
            defaultValue: 'Primary Contact Information'
          })}
        />
      </div>
      
      <div className="mt-5">
        <Accordion
          behavior="singleExpand"
          items={alternateContactInformation}
          // onCollapse={handleCollapse}
          // onExpand={handleExpand}
        />
      </div>
    </div>

  );
});

export default CaseContact;
